export default function Background() {
  return (
    <div className="bg-wrapper">
      <div className="shape-blob"></div>
      <div className="shape-blob one"></div>
      <div className="shape-blob two"></div>
    </div>
  );
}
